import React from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import PropTypes, { number } from 'prop-types';

import style from './LoadingMessage.module.scss';

const LoadingMessage = ({ message, size }) => (
  <div className={style.loadingMessageContainer}>
    {message}
    <CircleSpinner size={size} color="#3c4757" />
  </div>
);

export default LoadingMessage;

LoadingMessage.propTypes = {
  message: PropTypes.string,
  size: number,
};

LoadingMessage.defaultProps = {
  message: undefined,
  size: 30,
};
